<template>
  <div id="social_responsibility" class="background-color">
    <!--    <SocialResponsibilityTabs />-->
    <div class="random-cont">
      <random-section :error="newsError" :show="show" cardType="social" :data="socialSlider" v-if="staticCard" style="min-height: 500px" />
      <SliderSection  cardType="social" id="cards-slider" sliderHolder="socialResponsibility" :data="socialSlider" :obj="socialNewsRepo" method="get" v-if="slider" />
    </div>
    <!--    <PureTab :data="tabs"/>-->
    <div v-if="loadCategories" class="full-screen">
      <Loader />
    </div>
    <div v-if="errorCategories" class="full-screen">
      <Error class="pb-12" />
    </div>
    <div v-if="tabs.length > 0" class="TabsContainer">
      <v-tabs
        v-model="tab"
        background-color="#FFFFFF"
        color="#1D1D1D"
        grow
        centered
        show-arrows
        :class="[this.$lang === 'ar' ? 'left-dir' : 'left-dir', 'socialTab']"
      >
        <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
        <v-tab
          v-for="(item, index) in tabs" :key="index">{{item.title }}
        </v-tab>
      </v-tabs>
    </div>
    <div v-if="categoriesFetch" class="tabs-content">
      <v-tabs-items v-model="tab" :touchless="true">
        <v-tab-item  v-for="(item, i) in tabs" :key="i">
          <SliderSection id="press-social-card" sliderHolder="socialResponsibility" :extraUrl="tabsId[i].toString()" :obj="socialSliderRepo" method="getParamsById" :data="info[tab]" />
        </v-tab-item>
        <!--      <v-tab-item>-->
        <!--        <SliderSection :data="info" />-->
        <!--      </v-tab-item>-->
        <!--      <v-tab-item>-->
        <!--        <SliderSection :data="info" />-->
        <!--      </v-tab-item>-->
      </v-tabs-items>
    </div>
    <!--    <SliderSection :data="info" />-->
  </div>
</template>

<script>
import RandomSection from '../../components/sections/RandomCards'
import SliderSection from '../../components/sections/SliderSection'
import $ from 'jquery'
// import SocialResponsibilityTabs from '../../components/tabs/SocialResponsibilityTabs'
// import PureTab from '../../components/tabs/PureTab'
import SocialResponsibilityCategoriesRepository from '../../repositories/SocialResponsibilityCategoriesRepository'
import SocialResponsibilityNewsRepository from '../../repositories/SocialResponsibilityNewsRepository'
import SocialResponsibilitySliderRepository from '../../repositories/SocialResponsibilitySliderRepository'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'SocialResponsibility',
  components: { SliderSection, RandomSection, Loader, Error },
  data () {
    return {
      tab: 0,
      socialSliderRepo: new SocialResponsibilitySliderRepository(),
      socialCategoriesRepo: new SocialResponsibilityCategoriesRepository(),
      socialNewsRepo: new SocialResponsibilityNewsRepository(),
      info: [{
        sliderType: 'press&social',
        main: { sectionId: 'social_responsibility', cardType: 'social-responsibility', title: this.$t('socialResponsibility.title'), description: this.$t('socialResponsibility.desc'), image: '' },
        slider: []
      }],
      socialSlider: {
        sliderType: 'cardsMiniSlider',
        main: { sectionId: 'press_releases_slider', cardType: 'press_releases_slider', title: this.$t('socialResponsibility.title'), description: this.$t('socialResponsibility.desc'), image: '' },
        slider: [{ title: '', description: '', icon: '', styles: 'main' },
          { title: '', description: '', icon: '', styles: 'second' },
          { title: '', description: '', icon: '', styles: 'third' }
        ]
      },
      tabs: [],
      tabsId: [],
      fetched: false,
      totalPages: [],
      page: 0,
      size: 4,
      visited: [],
      firstFetch: 4,
      sliderFetched: false,
      temp: 0,
      show: false,
      sliderError: false,
      newsError: false,
      visitedTabs: [],
      slider: false,
      staticCard: true,
      url: 0,
      categoriesFetch: false,
      loadCategories: false,
      errorCategories: false
    }
  },
  watch: {
  },
  created () {
    this.handleCategories()
    this.handleSocialResponsibilityNews()
    this.hideSlider()
    this.$store.state.prevRoute = this.$lang === 'ar' ? 'أخبار اجتماعية' : 'Social'
  },
  mounted () {
    setTimeout(() => {
      this.arabic()
    })
    window.addEventListener('resize', () => {
      this.hideSlider()
    })
  },
  methods: {
    hideSlider () {
      if (window.innerWidth > 1100) {
        this.staticCard = true
        this.slider = false
      } else if (window.innerWidth <= 1100) {
        this.staticCard = false
        this.slider = true
      }
    },
    async handleSocialResponsibilityNews () {
      try {
        const response = await this.socialNewsRepo.get()
        if (response.status === 200) {
          this.socialSlider.slider = []
          for (let i = 0; i < response.data.length; i++) {
            this.socialSlider.slider.push({
              id: response.data[i].id,
              title: response.data[i].title,
              description: response.data[i].text,
              icon: gc.baseUrl + '/customerCare' + response.data[i].socialResponsibilityMedia[0].media,
              styles: i === 0 ? 'main' : i === 1 ? 'second' : 'third'
            })
          }
          this.show = true
        } else {
          this.newsError = true
          this.show = false
        }
      } catch (e) {
        this.newsError = true
        this.show = false
        console.log(e)
      }
    },
    async handleCategories () {
      try {
        this.loadCategories = true
        const response = await this.socialCategoriesRepo.get()
        if (response.status === 200) {
          this.info = []
          for (let i = 0; i < response.data.length; i++) {
            this.info.push({
              sliderType: 'press&social',
              main: { sectionId: 'social_responsibility', cardType: 'social-responsibility', title: this.$t('socialResponsibility.title'), description: this.$t('socialResponsibility.desc'), image: '' },
              slider: []
            })
            this.tabs.push(response.data[i])
            this.tabsId.push(response.data[i].id)
            this.categoriesFetch = true
          }
          this.loadCategories = false
          setTimeout(() => {
            this.arabic()
            this.info[0].sliderShow = true
          })
        } else {
          this.errorCategories = true
          this.loadCategories = false
        }
      } catch (e) {
        this.errorCategories = true
        this.loadCategories = false
        return e
      }
      this.loadCategories = false
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.socialTab .v-tab').css('transform', 'rotateY(180deg)')
        $('.v-tab').css('direction', 'rtl')
        $('.circle-background').css('transform', 'rotate(0deg)')
        $('#social_responsibility .TabsContainer').addClass('arabicTabContainer')
        $('#social_responsibility .random-cont').addClass('ar')
      } else {
        $('.v-tab').css('direction', 'ltr')
        $('#social_responsibility .random-cont').addClass('en')
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
@import "src/assets/sass/main";
@import "src/assets/sass/modules/tabs";
/*.v-tabs {*/
/*  height: 50px;*/
/*  background: rgba(242, 242, 242, 1)!important;*/
/*  padding: 0 4vw;*/
/*}*/
/*.v-tabs, .v-tabs-bar {*/
/*  height: 50px!important;*/
/*}*/
//#social_responsibility .random-cont {
//  background: url("../../assets/images/back1.png");
//}
#social_responsibility .random-cont.ar {
  background: url("../../assets/images/circles-back-ar.png") no-repeat right;
}
#social_responsibility .random-cont.en {
  background: url("../../assets/images/circles-back-en.png") no-repeat;
}
.arabicTabContainer{
  direction: ltr;
  transform: rotateY(180deg) !important;
}
#social_responsibility{
  padding-top: 3.5rem;
  margin-top: 100px;
  min-height: calc(100vh - 395px);
  .full-screen{
    min-height: 500px;
    .loader,
    .error-container{
      min-height: 500px !important;
    }
  }
}
.background-color{
  background: #F2F2F2;
}
/*.TabsContainer{*/
/*  box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;*/
/*  position: absolute;*/
/*  z-index: 1;*/
/*  width: 100vw;*/
/*}*/
.tabs-content{
  margin-top: 50px; //65px
}
/*<!--.socialTab .v-tab&#45;&#45;active {-->*/
/*<!--  color: $&#45;&#45;yellow !important;-->*/
/*<!--  font-family: Mtn-bold;-->*/
/*<!--  font-style: italic;-->*/
/*<!--  font-size: 12px !important;-->*/
/*<!--}-->*/
.socialTab .v-tab {
  font-size: 10px;
}
.transform{
  transform: rotateY(180deg) !important;
}
</style>
<style lang="scss">
#social_responsibility{
  .TabsContainer {
    box-shadow: none !important;
  }
  .v-tabs {
    /*padding: 0 4vw;*/
    background: rgba(255,255,255,0.4) !important;
    border-top: 2px solid rgba(255,255,255,1);
    border-bottom: 2px solid rgba(255,255,255,1);
  }
}
#social_responsibility{
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .v-tabs{
    height: 100%;
    border-bottom: none !important;
    padding: 0 0 !important;
  }
  .v-tab{
    font-size: 12px !important;
    border-bottom: 2px solid #ffffff;
  }
  .v-tab.v-tab--active{
    color: #FFCB05;
  }
  .v-window.v-item-group.theme--light.v-tabs-items{
    background: transparent;
  }
}
</style>
<style>
.v-tabs.nav-tab.v-tabs--centered.v-tabs--grow.theme--light {
  position: relative;
}

.v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--is-mobile.v-tabs-bar--show-arrows.primary--text, .v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--show-arrows.primary--text {
  position: absolute;
  top: 2px;
}
</style>
